import { FC, memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import parse from 'html-react-parser';

import { COMMON_CONTAINER_ID } from '@/config';
import { amlbotAPI, SendConfirmationEmailResponse } from '@/api';
import { AlertBox, Button } from '@/components';
import { useApiCall } from '@/hooks';

import styles from './NoticeConfirmationEmail.module.sass';

const DELAY = 60 * 1000;

interface NoticeConfirmationEmailProps {}

const NoticeConfirmationEmail: FC<NoticeConfirmationEmailProps> = (props) => {
  const { t } = useTranslation();
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    if (isDisabled) {
      setTimeout(() => {
        setIsDisabled(false);
      }, DELAY);
    }
  }, [isDisabled]);

  const [clickHandler, isLoading] = useApiCall(async () => {
    const data: SendConfirmationEmailResponse =
      await amlbotAPI.sendConfirmationEmail();

    if (data.success) {
      toast.success(t('translation.confirmation_email_notify_send'), {
        containerId: COMMON_CONTAINER_ID,
      });
    } else {
      console.log('Email has not been sent. Unexpected');
    }

    setIsDisabled(true);
  });

  return (
    <AlertBox type="info" className={styles.notice}>
      {{
        title: t('translation.verify_email_alert_title'),
        description: parse(t('translation.verify_email__alert_description')),
        actions: (
          <Button
            size="s"
            type="primary"
            corner="rect"
            onClick={clickHandler}
            disabled={isLoading || isDisabled}
          >
            {t('translation.resend_confirmation_email_btn')}
          </Button>
        ),
      }}
    </AlertBox>
  );
};

export default memo(NoticeConfirmationEmail);
